export const spacings = {
    xxs: '2px',
    xs: '6px',
    s: '8px',
    m: '12px',
    l: '16px',
    xl: '32px',
    xxl: '64px',
  } as const;
  
